import React from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Button from "components/Button";
import COLORS from "shared/constants/colors";
import { stepsData } from "pages/order-details/data";
import { ROUTES } from "shared/constants/routes";
import { isDecorationNotNeeded } from "selectors/products";
import {
  Container,
  StepWrapper,
  Step,
} from "styles/pages/order-details/orderSteps";

const OrdersStep = ({ activeStepIndex, updateActiveIndex, order = {} }) => {
  const emailid = useSelector((state) => state?.auth?.profile?.emailid);
  const products = useSelector((state) => state?.products?.data);
  const history = useHistory();
  let isArtWorkPending = false;
  let isFulfillmentPending = false;

  const { OrderLines } = order;
  if (OrderLines?.length) {
    const { OrderLineItems } = OrderLines[0];

    isArtWorkPending = !!_.find(OrderLineItems, (c) => {
      const decorationOptional = isDecorationNotNeeded(products, c.ProductID);

      if (c.aopVectorFile || decorationOptional) {
        return false;
      }
      return c?.printAreas?.length > 0
        ? !c?.printAreas?.find((p) => p?.artwork)
        : !c.ArtworkId && !c.BackArtworkId;
    });
    isFulfillmentPending = !!_.find(OrderLineItems, (c) => !c.FulfillmentCost);
  }

  return (
    <Container>
      <StepWrapper>
        {stepsData.map((step, index) =>
          index > 1 &&
          (order?.Status === "PendingDetails" ||
            isArtWorkPending ||
            isFulfillmentPending) &&
          index === 1 &&
          !order?.PrintProvider ? null : (
            <Step
              key={`step${index}`}
              onClick={() =>
                _.isFunction(updateActiveIndex) && updateActiveIndex(index)
              }
              active={activeStepIndex === index}
            >
              <p>
                {step.icon}
                {step.title}
              </p>
            </Step>
          )
        )}
      </StepWrapper>
      <Button
        containerStyle={{
          backgroundColor: COLORS.WHITE,
          fontSize: "14px",
          borderRadius: "3px",
          padding: "5px 10px",
          color: "inherit",
          fontWeight: "normal",
          textTransform: "initial",
          border: "1px solid #e7eaec",
          boxShadow: "none",
          alignSelf: "flex-start",
        }}
        title="Back to Orders"
        startIcon={<ArrowBackIosIcon />}
        onClick={() => history.push(ROUTES.ORDERS.LINK)}
      />
    </Container>
  );
};

export default OrdersStep;
